import api from '@/api/tecnologico.api'

let servicio = {}

servicio.caracteristicasCon = (idPlan) => {
    return api.get(`/caracteristicasplan/caracteristicasplancon/${idPlan}`)
}

servicio.guardar = (data) => {
    return api.post('/caracteristicasplan/guardarcaracteristica', data)
}

servicio.cambiarEstatus = (data) => {
    return api.post('/caracteristicasplan/cambiarestatuscaracteristica', data)
}

export default servicio
